import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import HeaderLayout from "./../Layout/Header";
import jwt_decode from "jwt-decode";

const HomeDashboard = () => {

    const navigate = useNavigate();

    const breadcrumbsLinks = []; 

    const [userName, setUserName] = useState('');
    const [courseName, setCourseName] = useState('');
    const [batchName, setBatchName] = useState('');

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        let userToken = JSON.parse(localStorage.getItem('userInfo'));
        let userInfo =  jwt_decode(userToken)    
        setUserName(userInfo.full_name);
        setCourseName(userInfo.course_name);
        setBatchName(userInfo.batch_name);
        
    }); 

    let pageTitle = 'DASHBOARD'
    
    return (
        <>
        <HeaderLayout pageTitle={pageTitle} />
        
        <section className="content app_dashboard">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>DASHBOARD</h2>
                </div> 
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="card">
                            <div className="body">
                                <div className="text label">Welcome Back,</div>
                                <div className="student_name">{userName}</div>
                                <div className="course_info">
                                    <div className="btn btn-sm btn-default waves-effect mr-5 mt-10">{courseName} - {batchName}</div>
                                    <div className="btn btn-sm btn-default waves-effect mt-10 expires">Expires 31-12-2026</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
                {/* <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div className="info-box bg-pink hover-expand-effect">
                            <div className="icon">
                                <i className="material-icons">playlist_add_check</i>
                            </div>
                            <div className="content">
                                <div className="text">NEW TASKS</div>
                                <div className="number count-to" data-from="0" data-to="125" data-speed="15" data-fresh-interval="20">125</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div className="info-box bg-cyan hover-expand-effect">
                            <div className="icon">
                                <i className="material-icons">help</i>
                            </div>
                            <div className="content">
                                <div className="text">NEW TICKETS</div>
                                <div className="number count-to" data-from="0" data-to="257" data-speed="1000" data-fresh-interval="20">257</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div className="info-box bg-light-green hover-expand-effect">
                            <div className="icon">
                                <i className="material-icons">forum</i>
                            </div>
                            <div className="content">
                                <div className="text">NEW COMMENTS</div>
                                <div className="number count-to" data-from="0" data-to="243" data-speed="1000" data-fresh-interval="20">243</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div className="info-box bg-orange hover-expand-effect">
                            <div className="icon">
                                <i className="material-icons">person_add</i>
                            </div>
                            <div className="content">
                                <div className="text">NEW VISITORS</div>
                                <div className="number count-to" data-from="0" data-to="1225" data-speed="1000" data-fresh-interval="20">1225</div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </section>
        </>
    );
   
}
    
export default HomeDashboard;